<template>
  <div id="" class="" v-if="innopearlAssessment">
    <div class="" v-if="$store.state.role == 'Expert' || $store.state.role == 'Admin'">
      <div class="realContentAssessment" v-if="innopearlAssessment.startups">
        <div class="container-fluid main_container" >
          <div class="row">
              <InnoViewSummary :internalAssessment="innopearlAssessment" @confirmed_innopearl_assess="confirmed_innopearl_assess" :votes="votes"/>
          </div>
        </div>
      </div>
    </div>
    <div class="" v-else>
      <div class="container">
        <div class="alert alert-danger">
           Your are not authorized to access to this ressource !
        </div>
      </div>

    </div>
  </div>
</template>
<script>
// import { QuillEditor } from '@vueup/vue-quill'
// import '@vueup/vue-quill/dist/vue-quill.snow.css';

//
// //import { Toaster, toast } from 'vue-sonner'
// import CreateCriteriaModal from '@/components/modals/createCriteria.vue'
// import CriteriaDetails from '@/components/CriteriaDetail.vue'
import InnoViewSummary from '@/components/InnoViewSummary.vue';
  import api from '../tools/api';
 import { toast } from 'vue-sonner'
export default {
  components: {
InnoViewSummary
    // QuillEditor,
    // CreateCriteriaModal,
  //   CriteriaDetails,
  //  StartupInfoLine
  },
  name: 'InnopearlAssessmentPreview',
  data() {
    return {
      dialog:false,
      pageInfo: {
        mainTitle : "My assessment space ",
        subTitle : this.$t("Preview"),
      },
      votes:[],
      nameForInit : "",
      demoValue:[],
      demoDisable:[],
      showSidePanelBasic: false,
      showDetailsIndexInSelected:null,
      showDetailsIndexInFav:null,
      step: 0,
      token:"",
      innopearlAssessment : {

      },

    }
  },
  methods:{
    confirmed_innopearl_assess(){
        this.innopearlAssessment.status = "completed";
    },
      getInnopearlAssessment(){
        api.get(process.env.VUE_APP_API_URL+"/restrict/innopearl_assessment/"+this.$route.params.id).then( (r) => {
          this.innopearlAssessment = r.data.assessment;
          this.votes = r.data.votes;
          console.log("sdfoqsdfiqspfdiqsdfp",r.data);
        }).catch( (e) => {
          console.log(e)
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      }
},
  mounted(){

    if(this.$route.params.id != "undefined"){
        this.getInnopearlAssessment();
     }
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

     // api.get(process.env.VUE_APP_API_URL+"/restrict/mycriteriabygroup").then( (r) => {
     //   this.criteriaGroups = r.data;
     //   console.log("criterias : ",r.data);
     //   console.log(r);
     // }).catch( (e) => console.log(e));

  },
  computed:{

},
watch:{

}

}
</script>
<style media="screen" scoped>
.internalAssessment{

}
.internalAssessment_inner{
  margin-top:50px;
  margin-bottom: 50px;
    padding: 50px;
    padding-top:25px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
}

.assessment-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    width: 100%;
        background-color: #fbfbfb;
        padding:20px;
}



.next-button {
    color: #fff;
    background: #3783C5 0% 0% no-repeat padding-box;
    padding: 14px 37px;
    border: none;
    display: flex;
    align-items: center;
        cursor: pointer;
        border-radius: 200px;
}

.status {
    display: flex;
    align-items: center;
    background-color: #f7e8c2;
    padding: 5px 15px;
    border-radius: 15px;
}

.status-text {
    color: #996600;
    font-size: 14px;
}


.next-button .v-img{
  margin-left:10px;
}

.left{

  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
}
@media screen and (max-width:990px){
  .assessment-navigation{
    flex-direction: column;
        align-items: left;
    gap:20px;
    padding: 10px;
  }

  .left {
    flex-wrap: wrap;
  }
}
.oneInfoAboutTitle{
  font-size:14px;
  font-weight:700;
  color:#000;
}
.mainColTitle{
  color:rgba(4, 36, 106, 1);
  font-size:20px;
  font-weight: 700;
}
.internalAssessmentContent2Col .criterias,
.internalAssessmentContent2Col .judges{
  padding:20px;
}
.internalAssessmentContent2Col .criterias{

  border:1px solid rgba(55, 131, 197, 1);
  border-radius:20px;
}
.criteriaList{
  display:flex;
  flex-direction: column;
  gap:20px;
  margin-top:20px;
}
.oneCriteria .criteriaHead{
  display:flex;
  gap:10px;
  position:relative;
}
.oneCriteria .criteriaHead .criteriaName{
  font-weight: 700;
  font-size:14px;
  color:rgba(10, 32, 113, 1);
}
.criteriaHead .v-img{
  width:18px;
  flex:none;
}

.vsliderIndicator{
  font-size:15px;
  font-weight: 500;
  color:#000;
}

.selectIt{


display:flex;
align-items: center;
gap: 10px;
}
.selectIt input{
  width:24px;
  height:24px;
}

.criteriaVoting{
  display:flex;
  gap:20px;
  align-items: center;
}
.criteriaVoting .slider{
  width:70%;
}


.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: rgba(4, 36, 106, 1);
  font-weight: 600;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  position:relative;
}

.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;
margin-top:10px;
height: 40px;
padding: 5px;
width:100%;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}

textarea.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 height:60px;

}

.feedBacks{
  margin-top:50px;
  border-top:1px solid #125AA433;
  padding-top:50px;
  margin-bottom: 50px;
}

.internalAssessmentContent2Col{
  margin-top:50px;
}


.selectedStartups{
  margin-top:50px;
  padding:50px;
  background:rgba(245, 250, 255, 1);
  border-radius: 15px;
}
.selectedStartups .titleText{
  font-size:20px;
  font-weight: 700;
  text-align:center;
  color:rgba(4, 36, 106, 1);
}



  .selectCandidateCard{
    background:#FFF;
  }
  .selectCandidateCard  .candidate_card_head{
      color: #4c81c0;
      padding: 10px 0px;
      background: #FFF;
      text-transform: uppercase;
      font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
      display:flex;
      align-content: center;
        align-items: center;
    gap:10px;
    min-height: 60px;

  }
  .candidate_card_head .name{
    flex:1;
  }
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content{
  padding:10px 20px ;
  flex-grow: 1;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}

  .candidate_card_head{
    background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;

    padding: 10px;
    color: #FFF;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 10px 10px 0px 0px;
    display:flex;
    align-content: center;
      align-items: center;
  gap:10px;
  min-height: 60px;
  }

  .selectCandidateCard .titreProperty{
    color:rgba(75, 82, 162, 1);
    font-size:14px;
    font-weight: 400;
    width:100%;
    display:block;
  }
  .selectCandidateCard .valueProperty{
    color:rgba(10, 32, 113, 1);
    font-size:14px;
    font-weight: 700 !important;
    width:100%;
    display:block;
  }

  .footer_link_cc{
 padding-left:20px;
 padding-right:20px;
 margin-bottom:20px;
 margin-top:20px;
  }
  .footer_link_cc a{
      display:block;
      width:100%;
      background:#4c81c0;
      color:#FFF;
      border-radius: 10px;
      padding:10px;
      text-align: center;
  }

  .listOfSelectedStartups{
    margin-top:25px;
  }
</style>

<style media="screen">
  .previewNewAssessment .v-slider-thumb__surface.elevation-2{
    border:1px solid rgba(18, 90, 164, 1) !important;
    color: rgba(18, 90, 164, 0.2) !important;
  caret-color: rgba(18, 90, 164, 0.2) !important;
  backdrop-filter: blur(40px);

  }
.previewNewAssessment .v-slider-thumb__ripple{
  color:#FFF !important;
    caret-color:#FFF !important;
}
.previewNewAssessment .v-slider{
  margin-top:40px;
}
.previewNewAssessment .v-slider.v-input--horizontal .v-slider-thumb__label::before{
  display:none;
}
.previewNewAssessment .v-slider-thumb__label{
  background: #FFF;
  color: #BBB;
  border: 1px solid #BBB;
  border-radius: 10px;
}
.previewNewAssessment  .v-slider.v-input--horizontal .v-slider-thumb__label{
  bottom:10px;
}
.previewNewAssessment .v-slider-track__background{
  background-color: #E1E1E1 !important;
  opacity: 1;
}
.previewNewAssessment  .v-slider .v-input__control{
  margin-left:10px;
  margin-right: 10px;
}

.listOfJudges{
  display:flex;
  gap:20px;
  margin-top:10px;
  flex-wrap: wrap;
}



.oneJudgeSelected{
  background:#480C831A;
  color:#480C83;
  padding:5px 20px;
  display:flex;
  gap:10px;
  border-radius: 50px;
  border: 1px solid #480C831A;
  position:relative;
}
.subTitleJudge{
  font-size:16px;
  font-weight: 700;
  color:#04246A;
  margin-bottom:10px;
  display:block;
  width:100%;
}

.judgesWithLicenses
{
    padding-top:35px;
padding-bottom:25px;
border-bottom: 1px solid #BACFE5;
}
.judgesWithoutLicences{
  padding-top:35px;
padding-bottom:25px;
border-bottom: 1px solid #BACFE5;
}

.oneInfoAboutValue p{
  padding:0;
  margin:0;
}

.innerWelcome{
  background:#FFF;max-width:750px;width:80%;
  padding:50px;border-radius:20px;z-index:20;
}
@media screen and (max-width:990px){
  .hideOnResponsive{
    display:none;
  }
  .innerWelcome{
    width:95%;
  }
}
#content{
  /* margin-left: 15%; */
  background : #EAEAEA;
  min-height: calc(100vh);
  padding-bottom: 50px;

}

.main_container > .row > .col{
  padding: 0px !important;
  margin: 0px !important;
}
.sidebarCol{
  min-height:100vh;position:relative;z-index:40;
      box-shadow: 0px 3px 6px #00000029;
}

.prev_step_btn,
.next_step_btn,
.contact_step_btn{
    display:inline-block;
}
.mt20{
  margin-top: 20px;
}

@media screen and (max-width: 1200px){
  #mainsidebar{
    display:none;
  }
  #content{
    margin-top: 100px;
  }
  #mainContent{
    width:100%;
  }


}

@media screen and (max-width: 990px){
  .prev_step_btn,
  .next_step_btn,
  .contact_step_btn{
    font-size: 12px;

}

button.step{
  display: flex;
flex-direction: column;

}
}

.v-theme--myCustomLightTheme{
      --v-disabled-opacity: 1 !important;
  }

  @media (min-width: 1400px){
  .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
  max-width: 90% !important;
  }

}

a, a:hover{
  text-decoration: none !important;
}

#footer{
      background : #EAEAEA;
      padding:20px;
      text-align:center;
      font-size: 12px;
      color:#333;
}
#footer a{
  text-align:center;
}

.sidebar_logo_extra_small{
  width: 80px;
height: 40px;
}
.v-btn--icon{
  border:none !important;
}

.footerAbs{
  position:absolute;
  bottom:20px;
  right:20px;
}

.inputFieldName input{
  border: 1px solid #3783C517;
  margin: auto;
    text-align: center;
  width: 100%;
  background: #3783C517;
  padding: 20px 10px;
  font-size: 20px;
  border-radius: 50px;
  color: #000;
}

</style>
